import styled from "@emotion/styled";
import { Icon, LightMode, Variables } from "@repo/skapa";

export const StyledRow = styled.div`
  display: flex;
  align-items: stretch;
  cursor: pointer;
  overflow: hidden;
  border-radius: ${Variables.radiusS};
  background-color: ${LightMode.colourStaticWhite};
  &:hover {
    background-color: ${LightMode.colourNeutral3};
  }
  &:focus-visible {
    outline: ${Variables.thicknessThick} solid
      ${LightMode.colourInteractivePrimaryBgDefault};
    outline-offset: -${Variables.thicknessThick};
  }
`;

export const ColorCell = styled.div<{ borderColor: string; dashed: boolean }>`
  flex: 0 0 ${Variables.space50};
  align-self: stretch;
  ${({ dashed, borderColor }) =>
    dashed
      ? `
      background-image: repeating-linear-gradient(
        135deg,
        ${borderColor},
        ${borderColor} 3px,
        transparent 3px,
        transparent 6px
      );
      background-size: ${Variables.space25} 100%;
      background-repeat: no-repeat;
      `
      : `background-color: ${borderColor};`}
`;

export const RowContent = styled.div`
  display: grid;
  grid-template-columns: 10rem 15fr 7fr 10fr 10fr 12rem;
  width: 100%;

  @media (max-width: ${Variables.breakpointL}) {
    grid-template-columns: 1fr;

    & > *:empty {
      display: none;
    }
  }
`;

export const TimeCell = styled.div<{ backgroundColor?: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 11 1 0;
  min-width: 0;
  padding: ${Variables.space75};
  white-space: nowrap;
  ${({ backgroundColor }) =>
    backgroundColor && `background-color: ${backgroundColor};`}
`;

export const TimeCellContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${Variables.space50};
`;

export const DetailsCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding: ${Variables.space75};
  overflow: hidden;
`;

export const InfoCell = styled.div<{ wide?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding: ${Variables.space75};
  overflow: hidden;
`;

export const LinkButton = styled.div`
  button {
    text-decoration: underline;
  }
`;

export const IconLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${Variables.space50};
  min-width: 0;
  svg {
    flex: 0 0 auto;
    width: ${Variables.space125};
    height: ${Variables.space125};
  }
`;

export const TwoLineClamp = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const ActionsCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  padding: ${Variables.space75};
  white-space: nowrap;
`;

export const ActionsCellContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${Variables.space50};
`;

export const ActionsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: ${Variables.space100};
`;

export const ItemIcon = styled(Icon)`
  flex-shrink: 0;
`;
